<template>
  <Header />
  <h1>Revisions</h1>

  <div class="current-time-container">
    <div class="filter-container">
      <input type="text" v-model="userSearchQuery" placeholder="Search by User ID" />
      <input type="text" v-model="keySearchQuery" placeholder="Search by Key" />
      <input type="text" id="oldValueFilter" v-model="oldValueSearchQuery" placeholder="Search by Old Value" />
      <input type="text" v-model="newValueSearchQuery" placeholder="Search by New Value" />
      <input type="text" id="genericProductFilter" v-model="revisionIDSearchQuery" placeholder="Search by Revision ID" />
      <input type="text" id="productFilter" v-model="revisionNameSearchQuery" placeholder="Search by Revision Name" />

      <button class="clear-filter-button" @click="clearFilters">Clear Filters</button>
    </div>
  </div>

  <div class="pagination-button-container">
    <div class="pagination-container">
      <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage" @page-change="onPageChange" />
    </div>
    <div class="pagination-info">
      Showing {{ startIndex + 1 }}-{{ endIndex }} of {{ filteredRevisionsLength }} revisions
    </div>
  </div>

  <div class="revisions-container">
    <div v-for="(group, key) in groupedRevisions" :key="key" class="revision-group">
      <div class="revision-header" @click="toggleGroup(key)">
        <h3>{{ key.split("#")[0] }} ID: {{ key.split("#")[1] }}</h3> <!-- Extract Type and ID -->
        <span>({{ group.length }} changes)</span>
        <span class="toggle-icon">{{ openGroups.includes(key) ? '▲' : '▼' }}</span>
      </div>

      <table v-if="openGroups.includes(key)">
        <thead>
          <tr>
            <th>User ID</th>
            <th>Key</th>
            <th>Old Value</th>
            <th>New Value</th>
            <th>Updated At</th>
            <th>Updated By</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in group" :key="item.id">
            <td>{{ item.user_id }}</td>
            <td>{{ item.key }}</td>
            <td class="old-value">{{ shortenString(item.old_value) }}</td>
            <td class="new-value">{{ shortenString(item.new_value) }}</td>
            <td>{{ getTimestamp(item.updated_at) }}</td>
            <td>{{ userDisplay(item) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="Object.keys(groupedRevisions).length === 0" class="revision-empty-group">
      <p style="text-align: center; margin-bottom: 0px;">No Matching Revisions</p>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue';
import axios from 'axios';
import Pagination from './TablePagination.vue';

export default {
  name: 'ViewRevisions',
  components: {
    Pagination,
    Header,
  },

  data() {
    return {
      revisions: [],
      userSearchQuery: '',
      keySearchQuery: '',
      oldValueSearchQuery: '',
      newValueSearchQuery: '',
      revisionIDSearchQuery: '',
      revisionNameSearchQuery: '',
      currentPage: 1,
      perPage: 50,
      totalPages: 0,
      filteredRevisionsLength: 0,
      openGroups: []
    };
  },
  watch: {
    userSearchQuery(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1; // Reset currentPage to 1 when searchQuery changes
        this.calculateTotalPages();
      }
    },
    revisionIDSearchQuery(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1; // Reset currentPage to 1 when searchQuery changes
        this.calculateTotalPages();
      }
    },
    revisionNameSearchQuery(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1; // Reset currentPage to 1 when searchQuery changes
        this.calculateTotalPages();
      }
    },
    keySearchQuery(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1; // Reset currentPage to 1 when searchQuery changes
        this.calculateTotalPages();
      }
    },
    oldValueSearchQuery(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1; // Reset currentPage to 1 when searchQuery changes
        this.calculateTotalPages();
      }
    },
    newValueSearchQuery(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1; // Reset currentPage to 1 when searchQuery changes
        this.calculateTotalPages();
      }
    },
  },
  async mounted() {
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      // Fetch all Revisions
      let result = await axios.get('/api/revisions', { headers });

      if (result.status === 200) {
        this.revisions = result.data;
        this.calculateTotalPages();
      }

    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
  },


  methods: {
    userDisplay(item) {
      const parts = [item.user_name, item.user_role];
      if (item.user_second_role) parts.push(item.user_second_role);
      return parts.join(', ');
    },
    // Function to get a timestamp in a specific format
    getTimestamp(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based in JavaScript
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      // Format the date and time
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    shortenString(value, maxLength = 100) {
      if (value && value.length > maxLength) {
        return value.substring(0, maxLength) + '...';
      }
      return value;
    },
    // deleteTrainee(user_id) {
    //   if (confirm("Are you sure you want to delete this trainee?")) {
    //     if (confirm("This action will PERMANENTLY delete the user from the database. Do you wish to continue?")) {
    //       // If the user confirms the deletion, send a request to delete the trainee.
    //       const token = localStorage.getItem('token');
    //       const headers = { Authorization: `Bearer ${token}` };

    //       axios
    //         .delete(`/api/users/${user_id}`, { headers })
    //         .then(response => {
    //           if (response.status === 200) {
    //             // Remove the deleted trainee from the local data
    //             this.revisions = this.revisions.filter(trainee => trainee.user_id !== user_id);

    //             window.alert('User deleted Successfully');
    //           }
    //         })
    //         .catch(error => {
    //           console.error('An error occurred while deleting the trainee:', error);
    //         });
    //     }
    //   }
    // },
    onPageChange(page) {
      this.currentPage = page;
      this.calculateTotalPages();
    },
    calculateTotalPages() {
      this.computeFilteredRevisions();
      this.totalPages = Math.ceil(this.filteredRevisionsLength / this.perPage);
    },
    computeFilteredRevisions() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;

      const filteredRevisions = this.revisions.filter((revision) => {

        // Exclude records where the key is 'updated_at'
        if (revision.key === 'updated_at' || revision.key === 'password' || revision.key === 'is_assessor') {
          return false;  // Skip this record
        }
        if (revision.revisionable_type === 'LogbookEntry' || revision.revisionable_type === 'Evaluation' || revision.revisionable_type === 'Note' || revision.revisionable_type === 'Group') {
          return false;
        }

        // Safely check revisionable_id
        const revisionIDMatch = (revision.revisionable_id ? revision.revisionable_id.toString() : '').includes(this.revisionIDSearchQuery) || this.revisionIDSearchQuery === '';

        const revisionName = (revision.revisionable_type || "").toLowerCase();
        const revisionNameMatch = revisionName.includes(this.revisionNameSearchQuery.toLowerCase()) || this.revisionNameSearchQuery === '';

        const userMatch = (revision.user_id ? revision.user_id.toString() : '').includes(this.userSearchQuery) || this.userSearchQuery === '';

        const key = (revision.key || "").toLowerCase();
        const keyMatch = key.includes(this.keySearchQuery.toLowerCase()) || this.keySearchQuery === '';

        const old_value = (revision.old_value || "").toLowerCase();
        const oldValueMatch = old_value.includes(this.oldValueSearchQuery.toLowerCase()) || this.oldValueSearchQuery === '';

        const new_value = (revision.new_value || "").toLowerCase();
        const newValueMatch = new_value.includes(this.newValueSearchQuery.toLowerCase()) || this.newValueSearchQuery === '';

        return revisionIDMatch && revisionNameMatch && userMatch && keyMatch && oldValueMatch && newValueMatch;
      });

      this.filteredRevisionsLength = filteredRevisions.length;
      return filteredRevisions.slice(startIndex, endIndex);
    },
    toggleGroup(id) {
      if (this.openGroups.includes(id)) {
        this.openGroups = this.openGroups.filter(group => group !== id);
      } else {
        this.openGroups.push(id);
      }
    },
    clearFilters() {
      // Clear all filter-related data properties
      this.searchQuery = '',
        this.logbookSearchQuery = '',
        this.categorySearchQuery = '',
        this.licenseSearchQuery = '',

        // Recalculate the total pages and update the data
        this.calculateTotalPages();
    },
  },
  computed: {
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      const end = this.startIndex + this.perPage;
      return end < this.filteredRevisionsLength ? end : this.filteredRevisionsLength;
    },
    filteredRevisions() {
      return this.computeFilteredRevisions();
    },
    groupedRevisions() {
      return this.filteredRevisions.reduce((acc, revision) => {
        const groupKey = `${revision.revisionable_type}#${revision.revisionable_id}`; // Unique key using both fields

        if (!acc[groupKey]) {
          acc[groupKey] = [];
        }

        acc[groupKey].push(revision);
        return acc;
      }, {});
    },
  },
};
</script>


<style scoped>
span:hover {
  cursor: pointer;
  color: blue;
}

input[type="text"] {
  width: 100%;
  height: 35px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 5px;
  margin-bottom: 1px;
  margin-right: 20px;
}

input[type="text"]#genericProductFilter {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
  position: absolute;
  right: 210px;
  top: 0px;
}

input[type="text"]#productFilter {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
  position: absolute;
  right: 210px;
  top: 41px;
}

input[type="text"]#oldValueFilter {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 200px;
  position: absolute;
  right: 210px;
  top: 82px;
}




h1 {
  padding-top: 30px;
  margin-right: 100%;
  padding-left: 3%;
}

.filter-container {
  margin: 20px 0;
  position: absolute;
  width: 200px;
  top: 0px;
  right: 20px;
}

label {
  margin-top: 8px;
}

.current-time-container {
  position: absolute;
  top: 80px;
  right: 10px;

}

.pagination-container {
  margin-top: 40px;
  margin-bottom: 0;
  display: flex;
  margin-left: 3%;
}

.clear-filter-button {
  position: absolute;
  right: 50px;
  top: 142px;
  width: 120px;
  border-radius: 5px;
  background-color: #dee2e6;
  font-size: 14px;
  height: 30px;
  border: 2px solid black;
  line-height: 0px;
}

.clear-filter-button:hover {
  background-color: #cecece;
  cursor: pointer;
}

.pagination-button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}


.pagination-info {
  font-size: 14px;
  color: #666;
  /* Adjust the color as needed */
  position: absolute;
  top: 250px;
  left: 50%;
  /* Center horizontally */
  transform: translateX(-50%);
  /* Center horizontally */
}

.revisions-container {
  max-width: 98%;
  margin: 0 auto;
  margin-top: 20px;
  padding: 5px;
}

.revision-group {
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
}

.revision-empty-group {
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  /* Centers horizontally */
  align-items: center;
  /* Centers vertically */
  margin: 0;
}

.revision-header {
  background: #f4f4f4;
  padding: 10px;
  font-size: 1.1em;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.toggle-icon {
  font-size: 1.2em;
  font-weight: bold;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

th {
  background: #eee;
}

.old-value {
  color: red;
}

.new-value {
  color: green;
}

span {
  margin-top: 0px;
  border: none;
}

h3 {
  font-size: 1.5rem;
}
</style>